export default __webpack_public_path__ + "static/DSC_0097-7e67dcc1782109a8aa26aafc2603d00d.jpg";